import type { HTMLComponent } from "@commercekit/react";
import { useRef, useState } from "react";
import type { UIEvent } from "react";
import WvProductItem from "~/components/molecules/WvProductItem";
import type { PopularProductsSliceHomePage } from "prismicio-types";
import type { WovarCustomer, WovarProduct } from "@commercekit/api";
import { asText } from "@prismicio/helpers";

const WvPopularProducts: HTMLComponent<{
  products: WovarProduct[];
  slice: PopularProductsSliceHomePage;
  customer?: WovarCustomer;
}> = ({ products, slice, customer }) => {
  const [canScrollLeft, setCanScrollLeft] = useState(products?.length > 2);
  const [canScrollRight, setCanScrollRight] = useState(false);

  const containerRef = useRef<HTMLDivElement>(null);

  const scroll = (direction: "LEFT" | "RIGHT") => {
    const left = direction === "LEFT" ? 370 : -370;
    containerRef.current?.scrollBy({ behavior: "smooth", left });
  };

  const handleScroll = (e: UIEvent) => {
    const left_offset = e.currentTarget.scrollLeft + 1;
    const container_width = e.currentTarget.scrollWidth;
    const visible_width = e.currentTarget.clientWidth;

    const right_offset = container_width - (visible_width + left_offset);

    setCanScrollLeft(right_offset > 1);
    setCanScrollRight(left_offset > 1);
  };

  return (
    <div className="component-products mb-5 pb-4 js-scroller w-full">
      <div className="container">
        <div className="component-product__slider text-center">
          <h2 className="heading xl underlined pb-3 mb-4 text-center">
            {asText(slice?.primary?.title)}
          </h2>
          <div className="row-scroller js-row-scroller">
            <div
              className="row justify-content-start no-gutters pl-md-0 pt-2"
              ref={containerRef}
              onScroll={handleScroll}
            >
              {products?.map((product, index) => (
                <WvProductItem
                  product={product}
                  key={index + product.sku}
                  className="col-11 col-sm-8 col-md-6 col-xl-4 component-productblock px-2 mb-4"
                  itemListId="home_popular_product"
                  itemListName="Home Popular Product"
                  customer={customer}
                  showOnlyPriceExclVat={slice?.primary?.show_only_price_excl_vat}
                />
              ))}
            </div>
          </div>
        </div>

        {products?.length > 0 ? (
          <>
            <div
              className={`component-products-prev d-none d-lg-block ${
                !canScrollRight ? "disabled" : ""
              }`}
              data-icon-before=""
              onClick={() => scroll("RIGHT")}
            ></div>
            <div
              className={`component-products-next d-none d-lg-block ${
                !canScrollLeft ? "disabled" : ""
              }`}
              data-icon-before=""
              onClick={() => scroll("LEFT")}
            ></div>
          </>
        ) : null}
      </div>
    </div>
  );
};
export default WvPopularProducts;
